// Progress data utility - simplified without migration

export interface ProgressData {
  [questionId: string]: {
    bookId: string;
    chapterId: string;
    mostRecentlyCorrect: boolean;
    questionId: string;
    questionData?: {
      question: string;
      type: 'true_false' | 'multiple_choice';
      options?: string[];
      correctAnswer?: string | boolean; // Can be string for multiple choice or boolean for true/false
      explanation?: string;
    };
    attempts: {
      userAnswer: string;
      timestamp: number;
      correct: boolean;
    }[];
  };
}

export function getProgressData(): ProgressData {
  const savedProgress = localStorage.getItem('quizProgress');
  console.log('getProgressData - Raw localStorage value:', savedProgress);
  if (!savedProgress) {
    console.log('getProgressData - No saved progress found');
    return {};
  }

  try {
    const progress = JSON.parse(savedProgress);
    console.log('getProgressData - Parsed progress:', progress);
    console.log('getProgressData - Progress keys:', Object.keys(progress));
    return progress as ProgressData;
  } catch (error) {
    console.error('Error loading progress data:', error);
    return {};
  }
} 